import { doc, getDoc, getFirestore } from "firebase/firestore";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { router } from "../../Constants";
import app from "../../firebase";
import { showLog } from "../../utils/log";
import ScreenOTP from "./ScreenOTP";

function KodeOTP(params) {
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [input, setInput] = React.useState({
    mobile: "",
    otp: "",
  });

  async function onOtp() {
    showLog("Otp Masuk onOtp");
    const code = input.otp;
    if (window.confirmationResult !== undefined) {
      window.confirmationResult
        .confirm(code)
        .then(async (result) => {
          // User signed in successfully.
          const user = result.user;
          // User couldn't sign in (bad verification code?)
          if (user) {
            const phone = user.phoneNumber;
            const db = getFirestore(app);
            const docRef = doc(db, "users", phone);
            const docSnap = await getDoc(docRef);
            let data = docSnap.data();
            localStorage.setItem("login", JSON.stringify(data));
            navigate(`${router}/order`);
          }
          setLoading(false);
        })
        .catch((error) => {
          switch (error.code) {
            case "auth/too-many-requests":
              setLoading(false);
              addToast("Too many requests, please try again after 5 minutes.", {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            case "auth/invalid-verification-code":
              setLoading(false);
              addToast("Nomor OTP tidak sama dengan yang dikirimkan", {
                appearance: "error",
                autoDismiss: true,
              });
              setInput((val) => ({
                ...val,
                otp: "",
              }));
              break;
            case "auth/code-expired":
              setLoading(false);
              addToast("Nomor OTP sudah expired, silahkan kirim ulang", {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              setLoading(false);
              addToast("An unknown error occured.", {
                appearance: "error",
                autoDismiss: true,
              });
              break;
          }
          showLog(`Otp = ${error}`);
        });
    } else {
      navigate(`${router}/login`);
    }
  }

  function onSubmitOTP(e) {
    showLog("Otp Masuk onSubmitOTP");
    setLoading(true);
    e.preventDefault();
    onOtp();
  }

  return (
    <ScreenOTP
      onClickBack={() => navigate(`${router}/login`)}
      input={input}
      setInput={setInput}
      onSubmitOTP={onSubmitOTP}
      loading={loading}
      ResendOTP={() => {
        {
          navigate(`${router}/login`);
        }
      }}
    />
  );
}

export default KodeOTP;
